import { ProjectModuleGasLiftLineBase } from './base/project-module-gas-lift-line-base';

export class ProjectModuleGasLiftLine extends ProjectModuleGasLiftLineBase { }